export const enableParallax = () => {
  const containers = document.getElementsByClassName('parallax-container')

  for (let i = 0; i < containers.length; i++) {
    const container = containers[i];
    const layers = container.getElementsByClassName('parallax-layer')

    container.addEventListener('mousemove', e => {
      const rect = container.getBoundingClientRect()
      const relX = e.clientX - rect.left
      const relY = e.clientY - rect.top

      const percentX = (relX / rect.width - 0.5) * 2
      const percentY = (relY / rect.height - 0.5) * 2

      for (let j = 0; j < layers.length; j++) {
        const layer = layers[j]
        const speed = parseFloat(layer.getAttribute('data-speed')) || 1

        const offsetX = -percentX * speed
        const offsetY = -percentY * speed

        layer.style.setProperty('--offset-x', `${offsetX}px`);
        layer.style.setProperty('--offset-y', `${offsetY}px`);
      }
    })

    container.addEventListener('mouseleave', () => {
      for (let j = 0; j < layers.length; j++) {
        const layer = layers[j]
        layer.style.setProperty('--offset-x', '0px')
        layer.style.setProperty('--offset-y', '0px')
      }
    })
  }
}
